// extracted by mini-css-extract-plugin
module.exports = {"title":"e_r7","author":"e_s7","container":"e_t7","image":"e_u7","uiHolder":"e_v7"};